var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovernance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 566.929,
    height: 377.953,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.936 22.815H384.46v239.328H26.936Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 283.465h425.197V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 377.953)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.844 2.844 0 0 0-2.835-2.835H-50.53A2.844 2.844 0 0 0-53.365 0v98.961a2.844 2.844 0 0 0 2.835 2.835h47.695A2.844 2.844 0 0 0 0 98.961Z",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(201.97 81.52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.844 2.844 0 0 0-2.835-2.835H-50.53A2.844 2.844 0 0 0-53.365 0v98.961a2.844 2.844 0 0 0 2.835 2.835h47.695A2.844 2.844 0 0 0 0 98.961Z",
    style: {
      fill: "#70bde5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(274.74 81.52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.844 2.844 0 0 0-2.835-2.835H-50.53A2.844 2.844 0 0 0-53.365 0v98.961a2.844 2.844 0 0 0 2.835 2.835h47.695A2.844 2.844 0 0 0 0 98.961Z",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(347.51 81.52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a1.48 1.48 0 0 0-1.479 1.479v101.624a1.48 1.48 0 0 0 2.958 0V1.479A1.48 1.48 0 0 0 0 0",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(355.423 79.748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a1.48 1.48 0 0 0-1.479 1.479v101.624a1.48 1.48 0 0 0 2.958 0V1.479A1.48 1.48 0 0 0 0 0",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(368.063 86.642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a1.48 1.48 0 0 0-1.479 1.479v101.625a1.48 1.48 0 0 0 2.958 0V1.479A1.48 1.48 0 0 0 0 0",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(380.702 93.635)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 106.732 45.348a11.346 11.346 0 0 0 8.868 0L222.333 0c2.841-1.207 1.979-5.444-1.109-5.444H1.108C-1.979-5.444-2.842-1.207 0 0",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(135.45 199.307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a1.5 1.5 0 0 0-1.472 1.799c.051.251.145 1.1-.785 1.495L-108.99 48.642a9.89 9.89 0 0 1-7.696 0L-223.417 3.294a1.5 1.5 0 1 0-1.174 2.761l106.733 45.348a12.91 12.91 0 0 0 10.041 0L-1.084 6.055C.864 5.228 1.89 3.277 1.468 1.202A1.501 1.501 0 0 0 0 0",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(382.897 209.724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.193 0-.392.038-.581.118l-109 45.915a1.5 1.5 0 1 0 1.164 2.764l109-45.914A1.5 1.5 0 0 0 0 0",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(373.618 203.308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.4 44.045H77.745v12.369H347.4ZM334.722 22.815H26.936v14.119h307.786zM360.025 62.173H125.164v10.773h234.861z",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernance);
export default __webpack_public_path__ + "static/media/governance.186e0182062f21c45476faaf9b3bb8cd.svg";
export { ForwardRef as ReactComponent };